import { ErpHeader, ErpDiv, ErpH1, ErpSpan, ErpP } from './ErpHtml';
import { iconFor } from '@/lib/iconRegistry';
import React, { ReactNode } from 'react';

export interface PageHeaderProps { 
  children?: React.ReactNode;
  title: string;
  subtitle?: string;
  folder?: string;
  page?: string;
  icon?: string;
  variant?: 'standard' | 'gradient' | 'elevated' | 'minimal';
  actions?: ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle = '',
  folder: _folder = '',
  page: _page = '',
  icon = '',
  variant: _variant = 'standard',
  actions,
  children
}) => {
  return (
    <ErpHeader className="mb-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
      <ErpDiv className="flex min-w-0 flex-col gap-0.5">
        <ErpH1 className="text-xl font-bold text-foreground tracking-tight flex items-center gap-2 break-words [overflow-wrap:anywhere]">
          {icon && <ErpSpan aria-hidden="true" className="inline-flex size-5 shrink-0 items-center justify-center text-muted-foreground">{iconFor(icon, 20)}</ErpSpan>}
          <ErpSpan className="min-w-0 break-words [overflow-wrap:anywhere]">{title}</ErpSpan>
        </ErpH1>

        {subtitle && <ErpP className="text-sm text-muted-foreground break-words">{subtitle}</ErpP>}
      </ErpDiv>
      <ErpDiv className="flex min-w-0 max-w-full items-center gap-2 flex-wrap md:ms-auto max-sm:[&_button]:h-auto max-sm:[&_button]:min-h-11 max-sm:[&_button]:max-w-full max-sm:[&_button]:whitespace-normal max-sm:[&_button[data-size^=icon]]:min-w-11">
        {actions}
        {children}
      </ErpDiv>
    </ErpHeader>
  );
};

const MemoizedPageHeader = React.memo(PageHeader);
export { MemoizedPageHeader as PageHeader };
export default MemoizedPageHeader;
